import { createSlice } from "@reduxjs/toolkit";

export const vendorOrderSlice = createSlice({
  name: "vendor-order",
  initialState: {
    isPostLoading: false,
    isLoading: false,

    vendorOrderData: [],
    message: "",
  },
  reducers: {
    onPostVendorOrder: (state) => {
      return {
        ...state,
        isPostLoading: true,
        vendorOrderData: [],
      };
    },

    onPostVendorOrderSuccess: (state, { payload }) => {
      const { postData = [], message = "", status_code = "200" } = payload;
      return {
        ...state,
        isPostLoading: false,
        vendorOrderData: postData,
        postMessage: message,
        post_status_code: status_code,
      };
    },

    onPostVendorOrderError: (state, { payload }) => {
      const { postData = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        vendorOrderData: postData,
        postMessage: message,
        post_status_code: status_code,
        isPostLoading: false,
      };
    },
    onPostVendorOrderReset: (state) => {
      return {
        ...state,
        isPostLoading: false,
        post_status_code: null,
      };
    },
  },
});

export const {
  onPostVendorOrder,
  onPostVendorOrderSuccess,
  onPostVendorOrderError,
  onPostVendorOrderReset,
} = vendorOrderSlice.actions;

export default vendorOrderSlice.reducer;
